import * as THREE from 'three';

export class TextureManager {
  private readonly loader = new THREE.TextureLoader();
  private readonly cache = new Map<string, Promise<THREE.Texture>>();

  load(url: string, colorSpace: THREE.ColorSpace = THREE.SRGBColorSpace): Promise<THREE.Texture> {
    const cached = this.cache.get(url);
    if (cached) return cached;

    const promise = this.loader.loadAsync(url).then((texture) => {
      texture.colorSpace = colorSpace;
      texture.anisotropy = 8;
      return texture;
    });
    this.cache.set(url, promise);
    return promise;
  }
}
